export default __webpack_public_path__ + "static/roadmap_mobile@2x-7dddd7c3b6aebd1b51d5364e4d4c513c.png";